import { formatEircode } from "utils/validators";

export const PHONE_PLACEHOLDER_HOME = "Enter phone number";
export const PHONE_PLACEHOLDER_MOBILE = "Enter mobile number";

export const LABEL_MOBILE_PHONE = "Mobile number";
export const LABEL_HOME_PHONE = "Home phone";

export const CREATE_DEFAULT_VALUES = {
  title: "",
  firstName: "",
  surname: "",
  dateOfBirth: "",
  gender: "",
  homePhone: "",
  mobilePhone: "",
  email: "",
  nationalNumber: "",
  noPpsn: false,
  doctorDetailsId: "",
  ethnicityCode: "",
  financialClass: "",
  gms: false,
  nextOfKin: "",
  nextOfKinRelationship: "",
  nextOfKinPhone: "",
  died: false,
  dateOfDeath: "",
  causeOfDeath: "",
  addressLine1: "",
  addressLine2: "",
  addressLine3: "",
  city: "",
  county: "",
  postCode: "",
  // Default a new patient's country to Ireland (ISO "IE"). CDM/PCRS requires an
  // Irish patient, and it is by far the common case, so pre-select it rather than
  // leaving the field blank. Editable, and the edit flow keeps the stored value.
  country: "IE",
  medicalCardNumber: "",
  mothersMaidenName: "",
  patientPreference: "",
  primaryGpContactId: null,
  primaryGpEmail: "",
};

export const getEditDefaultValues = (patient) => {
  if (!patient || typeof patient !== "object" || patient.id == null) {
    return { ...CREATE_DEFAULT_VALUES };
  }
  const financialClass = patient.financialClass || "";
  const isGMS = financialClass === "02" || financialClass === "04";
  const initialGms = patient.gms !== undefined ? patient.gms : isGMS;

  return {
    title: patient.title || "",
    firstName: patient.firstName || "",
    surname: patient.surname || "",
    nationalNumber: patient.nationalNumber || "",
    dateOfBirth: patient.dateOfBirth || "",
    mobilePhone: patient.mobilePhone?.trim() || "",
    homePhone: patient.homePhone || "",
    email: patient.email || "",
    gender: patient.gender || "",
    ethnicityCode: patient.ethnicityCode || "",
    financialClass,
    nextOfKin: patient.nextOfKin || "",
    nextOfKinRelationship: patient.nextOfKinRelationship || "",
    nextOfKinPhone: patient.nextOfKinPhone || "",
    noPpsn: patient.noPpsn ?? false,
    died: patient.died || false,
    dateOfDeath: patient.dateOfDeath || "",
    causeOfDeath: patient.causeOfDeath || "",
    doctorDetailsId: patient.doctorDetailsId
      ? String(patient.doctorDetailsId)
      : patient.doctorDetails?.id
      ? String(patient.doctorDetails.id)
      : "",
    gms: initialGms ?? false,
    medicalCardNumber: patient.medicalCardNumber || "",
    mothersMaidenName: patient.mothersMaidenName || "",
    patientPreference: patient.patientPreference || "",
    // The stored GP is the default, so a save that doesn't touch it sends it back unchanged
    // (the API clears whatever a save leaves out, KIN-2211).
    primaryGpContactId:
      patient.primaryGpContactId ?? patient.primaryGp?.id ?? null,
    primaryGpEmail: patient.primaryGpEmail || "",
    addressLine1: patient.address?.addressLine1 || "",
    addressLine2: patient.address?.addressLine2 || "",
    addressLine3: patient.address?.addressLine3 || "",
    county: patient.address?.county || "",
    postCode: formatEircode(patient.address?.postCode) || "",
    city: patient.address?.city || "",
    country: patient.address?.country || "",
  };
};

export const mapDoctorsToSelectOptions = (doctorsData) => {
  if (!doctorsData) return [];
  return doctorsData.map((element) => ({
    label: `${element.active ? "✅ " : ""}${element.firstName} ${
      element.lastName
    }${element.staffRole ? ` (${element.staffRole.toLowerCase()})` : ""}`,
    doctorName: `${element.firstName} ${element.lastName}`,
    firstName: element.firstName,
    lastName: element.lastName,
    value: element.id,
    profilePic: element.profilePic,
    active: element.active,
    staffRole: element.staffRole,
  }));
};
